export class Club {
    name: string;
    id: number;
    compliant: boolean;
    email: string;
    phone: string;
    removed_status: string;
    removed: boolean;
    image_path: string;
    types = [];
    stats = [];
    
    staff: any[];

    removed_count: number;
    removed_pending_count: number;
    staff_count: number;
    team_count: number;
    athlete_count: number;
    compliance_count: number;

    admin_title: string;
    admin_name: string;
    admin_email: string;
    admin_phone: string;

    constructor() { }

}


// WEBPACK FOOTER //
// ./src/app/_models/clubs.model.ts